export const MODE = {
  IFRAME: 'iframe',
  DIRECT: 'direct',
}

export const CELL = {
  EMPTY: 'empty', // ยังไม่ได้เลือกรถ
  STARTING: 'starting', // discovery / สั่งเปิดกล้องอยู่
  CONNECTING: 'connecting', // รอ backend บอก ready หรือได้ URL แล้วรอภาพแรก
  PLAYING: 'playing', // ยืนยันแล้วว่าภาพเดินจริง
  STALLED: 'stalled', // เคยเล่นแล้วภาพหยุดเดิน
  OFFLINE: 'offline', // พิสูจน์แล้วว่าอุปกรณ์ไม่ส่งภาพ
  ERROR: 'error', // สั่งเปิดไม่สำเร็จ หรือ player พัง
  STOPPED: 'stopped', // backend บอกว่า session จบแล้ว
  UNKNOWN: 'unknown', // พิสูจน์ไม่ได้ว่ามีภาพไหม (vendor ไม่ส่งสัญญาณ หรือบอกสถานะกล่องไม่ได้)
}

/** สถานะฝั่ง backend — คนละชุดกับ CELL ที่ละเอียดกว่าเพราะต้องบอกผู้ใช้ว่ารออะไร */
export const SESSION = {
  READY: 'ready',
  FAILED: 'failed',
  ENDED: 'ended',
}

export const END_REASON = {
  EXPIRED: 'expired',
  IDLE_TIMEOUT: 'idle_timeout',
  ERROR: 'error',
}

// หน้าเว็บขอ sub เสมอ เพื่อประหยัดเน็ต 4G ของรถ
export const QUALITY = {
  SUB: 'sub',
}

/** ค่าจาก stream.protocol ของ backend */
export const PROTOCOL = {
  HTTP_FLV: 'http-flv',
  WS_FLV: 'ws-flv',
  HLS: 'hls',
}

// สูงสุด 4 กรอบเหมือนหน้าเดิม — กรอบละหลายกล้อง เปิดมากกว่านี้เบราว์เซอร์ช้า
export const LAYOUTS = [1, 4]

export const PROGRESS_CHECK_MS = 1500
export const PROGRESS_MIN_DELTA = 0.2

export const STALL_AFTER_MS = 8000

// รอภาพแรกนานสุดเท่านี้ · นับหลัง ready เท่านั้น — OFFLINE หรือ UNKNOWN ให้ cellState ตัดสิน
// direct เจอบ่อยแปลว่า adapter ประกาศ ready เร็วไป
export const FIRST_FRAME_TIMEOUT_MS = 25000

export const POLL_FALLBACK_MS = 1000
export const POLL_MIN_MS = 500

// กันกรอบค้าง "กำลังเชื่อมต่อ" ตลอดกาลถ้า backend เงียบ — ปกติ backend เปลี่ยนเป็น failed เอง
export const CONNECT_TIMEOUT_FALLBACK_SEC = 25
export const CONNECT_GRACE_MS = 10000

// กัน vendor ที่ตั้งอายุสตรีมสั้นผิดปกติ ไม่ให้เปิดใหม่เองวนสั่งกล้องไม่จบ
// ใช้กับ idle_timeout ด้วย (แท็บถูกซ่อนจน heartbeat ไม่ถึง) กันเปิดใหม่วนถ้าแท็บถูกซ่อนซ้ำ ๆ
export const EXPIRED_REOPEN_MIN_GAP_MS = 5 * 60 * 1000

export const API_TIMEOUT_MS = 22000
